<template>
  <div class="home-container">
    <div class="top-info-con">
      <img src="./svg/success.svg" alt="" />
      <p class="one-t">开票申请成功</p>
      <p class="two-t">开票申请已经提交,请耐心等待</p>
    </div>
    <van-cell-group>
      <van-cell icon="award-o" title="票种" :value="zd[info?.fpzl] || '--'" />
      <van-cell icon="gold-coin-o" title="金额" :value="info?.je || '--'" />
      <van-cell icon="vip-card-o" title="订单号" :value="info?.dh?.join(',') || '--'" />
      <van-cell icon="user-o" title="抬头" :value="info?.khmc || '--'" />
      <van-cell icon="award-o" title="税号" :value="info?.khsh || '--'" />
    </van-cell-group>

    <van-button class="back-btn" type="primary" @click="back">返回</van-button>
    <div class="flex1"></div>
    <!-- <div v-if="gsInfo.smkpwc" class="adv">
      <img :src="gsInfo.smkpwc" alt="广告位" />
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Skeleton } from "vant";
import { Button } from "vant";
import { Icon } from "vant";
import { Toast } from "vant";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Skeleton);

export default {
  data() {
    return {
      zd: {
        "004": "专用发票",
        "026": "电子发票",
        "007": "普通发票",
        "028": "专用电子",
        "020": "全电专票",
        "021": "全电普票",
      },
      info: {},
    };
  },
  created() {
    try {
      this.info = JSON.parse(localStorage.getItem("kpwcInfo"));
    } catch (error) {
      console.log(error);
    }
    if (Object.keys(this.info).length === 0) this.back();
  },
  methods: {
    back() {
      this.$router.push({ path: "/orderList", query: { uid: localStorage.getItem("uid") } });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  height: calc(100vh - 58px);
  display: flex;
  flex-direction: column;

  .top-info-con {
    text-align: center;
    img {
      margin-top: 30px;
      height: 160px;
    }
    .one-t {
      font-size: 1.32rem;
      color: #333;
      font-weight: 500;
    }
    .two-t {
      font-size: 0.9rem;
      color: #666;
      font-weight: 500;
      position: relative;
      top: -8px;
    }
  }

  .adv {
    width: 100%;
    height: auto;
    max-height: 25vh;
    box-sizing: border-box;
    padding: 12px;
    overflow: hidden;
    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }

  .back-btn {
    height: 40px;
    border-radius: 20px;
    margin: 20px 12px;
  }
}
/deep/.van-cell__value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 2;
}
/deep/.van-cell-group {
  border-radius: 8px;
  overflow: hidden;
  margin: 0 12px;
}
</style>
